import React, { createContext, useContext, useState } from 'react';

const RulesCreateStateContext = createContext(null);

export const RulesCreateStateProvider = ({ children }) => {
  // All state from RulesCreate
  const [inputSourceFileData, setInputSourceFileData] = useState();
  const [selectedFileType, setSelectedFileType] = useState('');
  const [configFields, setConfigFields] = useState({});
  const [xmlStructure, setXmlStructure] = useState('');
  const [allowEdit, setAllowEdit] = useState(false);
  const [editId, setEditId] = useState('');
  const [openModal, setOpenModal] = useState(false);
  const [pageType, setPageType] = useState('Create');
  const [newVersionModal, setNewVersionModal] = useState(false);
  const [previousValues, setPreviousValues] = useState();
  const [currentValues, setCurrentValues] = useState({});
  const [selectedDateOption, setSelectedDateOption] = useState('current');
  const [selectedDate, setSelectedDate] = useState(null);
  const [ruleApplicabilityError, setRuleApplicabilityError] = useState(false);
  const [outputFormulaError, setOutputFormulaError] = useState(false);
  const [isSavedClick, setIsSavedClick] = useState(false);
  const [dmnData, setDmnData] = useState({
    inputFields: [],
    outputFields: [],
    data: [],
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [concatList, setConcatList] = useState([]);
  const [hasInvalidOutputColumn, setHasInvalidOutputColumn] = useState(false);
  const [hasInvalidInputColumn, setHasInvalidInputColumn] = useState(false);
  const [dmnErrors, setDmnErrors] = useState([]);
  const [isDmnValid, setIsDmnValid] = useState(false);
  const [ruleData, setRuleData] = useState();
  const [ruleGroupList, setRuleGroupList] = useState();
  const [previousXmlValues, setPreviousXmlValues] = useState();
  const [validationMsg, setValidationMsg] = useState(false);

  // Add more state as needed

  const value = {
    inputSourceFileData,
    setInputSourceFileData,
    selectedFileType,
    setSelectedFileType,
    configFields,
    setConfigFields,
    xmlStructure,
    setXmlStructure,
    allowEdit,
    setAllowEdit,
    editId,
    setEditId,
    openModal,
    setOpenModal,
    pageType,
    setPageType,
    newVersionModal,
    setNewVersionModal,
    previousValues,
    setPreviousValues,
    currentValues,
    setCurrentValues,
    selectedDateOption,
    setSelectedDateOption,
    selectedDate,
    setSelectedDate,
    ruleApplicabilityError,
    setRuleApplicabilityError,
    outputFormulaError,
    setOutputFormulaError,
    isSavedClick,
    setIsSavedClick,
    dmnData,
    setDmnData,
    validationErrors,
    setValidationErrors,
    concatList,
    setConcatList,
    hasInvalidOutputColumn,
    setHasInvalidOutputColumn,
    hasInvalidInputColumn,
    setHasInvalidInputColumn,
    dmnErrors,
    setDmnErrors,
    isDmnValid,
    setIsDmnValid,
    ruleData,
    setRuleData,
    setRuleGroupList,
    ruleGroupList,
    previousXmlValues,
    setPreviousXmlValues,
    validationMsg,
    setValidationMsg,
    // Add more state/setters as needed
  };

  return (
    <RulesCreateStateContext.Provider value={value}>
      {children}
    </RulesCreateStateContext.Provider>
  );
};

export const useRulesCreateState = () => useContext(RulesCreateStateContext);
